import { Route } from '@angular/router';

/**
 * Guest QR app routes. Main guest screens mount from the shell (`view.View`);
 * Stripe Checkout returns to static `public/on-payment/`, not a Router path.
 */
export const appRoutes: Route[] = [];
